import React from 'react'
import Button from '../button'
import * as S from './styles'

type Props = {
  image?:any
  inputs?:any
  closeModal:any
  title?:any
  className?:string
}
const Modal = ({
  image, inputs, closeModal, title, className,
}:Props) => {
  const clickOutside = (event: React.FormEvent) => {
    if (event.target === event.currentTarget) {
      closeModal()
    }
  }
  return (

    <S.Background onClick={(e) => clickOutside(e)}>
      <S.Wrapper
        className={className}
      >
        <S.Header>
          <Button onClick={closeModal}> X </Button>
          {title}
        </S.Header>
        <S.BodyContainer>
          {image}
          {inputs}
        </S.BodyContainer>
      </S.Wrapper>
    </S.Background>

  )
}
export default Modal
